import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import s from './StickySteps.css';
// Shared pill button base + responsive CTA sizing (.landingBtnCta)
import btn from '../shared/landingButtons.css';
import cs from '../../commonStyle.css';
import messages from '../../../locale/messages';
import { openLoginModal, openSignupModal } from '../../../actions/modalActions';

import renterImage from '../../../../images/new-landing/renter.png';
import ownerImage from '../../../../images/new-landing/owner.png';

class StickySteps extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool,
    openLoginModal: PropTypes.func.isRequired,
    openSignupModal: PropTypes.func.isRequired,
  };

  handleBookNowClick = (event) => {
    event.preventDefault();
    this.props.openLoginModal();
  };

  handleEarnNowClick = (event) => {
    event.preventDefault();
    this.props.openSignupModal();
  };

  render() {
    const { intl, isAuthenticated } = this.props;

    const renterSteps = [
      { number: '1', title: messages.newLandingStepRenter1Title, text: messages.newLandingStepRenter1Text },
      { number: '2', title: messages.newLandingStepRenter2Title, text: messages.newLandingStepRenter2Text },
      { number: '3', title: messages.newLandingStepRenter3Title, text: messages.newLandingStepRenter3Text },
      { number: '4', title: messages.newLandingStepRenter4Title, text: messages.newLandingStepRenter4Text },
      { number: '5', title: messages.newLandingStepRenter5Title, text: messages.newLandingStepRenter5Text },
    ];

    const ownerSteps = [
      { number: '1', title: messages.newLandingStepOwner1Title, text: messages.newLandingStepOwner1Text },
      { number: '2', title: messages.newLandingStepOwner2Title, text: messages.newLandingStepOwner2Text },
      { number: '3', title: messages.newLandingStepOwner3Title, text: messages.newLandingStepOwner3Text },
      { number: '4', title: messages.newLandingStepOwner4Title, text: messages.newLandingStepOwner4Text },
      { number: '5', title: messages.newLandingStepOwner5Title, text: messages.newLandingStepOwner5Text },
    ];

    const renderCards = (steps, dark) => (
      <div className={s.scrollCardsContainer}>
        {steps.map((step) => (
          <div key={step.number} className={s.stepRow}>
            <div className={cx(s.modernCard, dark && s.modernCardDark)}>
              <div className={s.stepNumber}>{step.number}</div>
              <h4><FormattedMessage {...step.title} /></h4>
              <p><FormattedMessage {...step.text} /></p>
            </div>
          </div>
        ))}
      </div>
    );

    return (
      <React.Fragment>
        <section id="renters" className={s.stickySection}>
          <div className={s.stickyScrollTrack}>
            <div className={s.stickyBgContainer}>
              <img src={renterImage} alt={intl.formatMessage(messages.newLandingRenterImageAlt)} className={s.stickyBgImage} />
              {!isAuthenticated && (
                <div className={s.stickyBtnWrapper}>
                  <a
                    href="#"
                    role="button"
                    onClick={this.handleBookNowClick}
                    // landingBtnCta: shared responsive sizing for long translated labels
                    className={cx(btn.landingBtn, btn.landingBtnCta, s.stickyBtnRenter)}
                  >
                    <FormattedMessage {...messages.newLandingBookNow} />
                  </a>
                </div>
              )}
            </div>
            {renderCards(renterSteps, false)}
          </div>
        </section>

        <section id="owners" className={cx(s.stickySection, s.stickySectionDark)}>
          <div className={s.stickyScrollTrack}>
            <div className={s.stickyBgContainer}>
              <img src={ownerImage} alt={intl.formatMessage(messages.newLandingOwnerImageAlt)} className={s.stickyBgImage} />
              {!isAuthenticated && (
                <div className={s.stickyBtnWrapper}>
                  <a
                    href="#"
                    role="button"
                    onClick={this.handleEarnNowClick}
                    // landingBtnCta: shared responsive sizing for long translated labels
                    className={cx(btn.landingBtn, btn.landingBtnCta, s.stickyBtnOwner)}
                  >
                    <FormattedMessage {...messages.newLandingEarnNow} />
                  </a>
                </div>
              )}
            </div>
            {renderCards(ownerSteps, true)}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated,
});

const mapDispatch = {
  openLoginModal,
  openSignupModal,
};

export default compose(
  injectIntl,
  connect(mapState, mapDispatch),
  withStyles(s, btn, cs),
)(StickySteps);
